module.exports = __webpack_public_path__ + "static/baby-2-62bac0fc0c61416b725f06481e034bf2.jpg";